/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { apiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import { removeItem } from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "clientpanel/subscription/";
var moduleName = "Subscriptions History";
class View extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || '',
      viewID: this.props.params?.EditID || "",
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      name: "",
      status: "",
      storeID: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  removeItem(deleteID) {
    var params = { delete_id: deleteID, company_id: this.state.companyID };
    var delurl = module + "delete";
    removeItem(params, delurl, "client");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, function () {});
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + "&company_id=" + this.state.companyID + "&detail_id=" + this.state.viewID,
      url: apiUrl + module + "details",
      authType: "client",
    };
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        storeID: "",
        status: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    var subscribePeriod = "";
    var subscribe_vouchers = [];
    var subscribstatus = "";
    if (this.state.listdata.length > 0) {
      if (this.state.listdata[0].subscribe_period === "W") {
        subscribePeriod = "Weekly";
      } else if (this.state.listdata[0].subscribe_period === "M") {
        subscribePeriod = "Monthly";
      } else if (this.state.listdata[0].subscribe_period === "Q") {
        subscribePeriod = "Quarterly";
      } else if (this.state.listdata[0].subscribe_period === "B") {
        subscribePeriod = "Biannually";
      } else if (this.state.listdata[0].subscribe_period === "A") {
        subscribePeriod = "Annually";
      }
      subscribe_vouchers = this.state.listdata[0].subscribe_vouchers !== "" && this.state.listdata[0].subscribe_vouchers !== null ? JSON.parse(this.state.listdata[0].subscribe_vouchers) : [];

      if (this.state.listdata[0].subscribe_status === "A") {
        subscribstatus = "Active";
      } else if (this.state.listdata[0].subscribe_status === "I") {
        subscribstatus = "Inactive";
      } else if (this.state.listdata[0].subscribe_status === "C") {
        subscribstatus = "Cancelled";
      } else if (this.state.listdata[0].subscribe_status === "P") {
        subscribstatus = "Pending";
      }
    }

    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"subscription"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/clientpanel/subscription"}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                {this.state.listdata.length > 0 && (
                  <div>
                    <p>
                      <b>SUBSCRIPTION NAME :</b> {this.state.listdata[0].subscribe_item_qty} X {this.state.listdata[0].subscribe_item_name} - {subscribePeriod}
                    </p>
                    <p>
                      <b>START DATE :</b> {this.state.listdata[0].subscribe_start_date}
                    </p>
                    <p>
                      <b>NEXT SUBSCRIPTION :</b> {this.state.listdata[0].subscribe_next_cycle}
                    </p>
                    <p>
                      <b>STATUS :</b> {subscribstatus}
                    </p>
                    <div>
                      <b>VOUCHERS :</b>{" "}
                      <ul>
                        {subscribe_vouchers.length > 0 &&
                          subscribe_vouchers.map((vitem, vindex) => {
                            return (
                              <li key={vindex}>
                                {vitem.quantity} X {vitem.product_name}
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                )}

                <div className="card">
                  <div className="table-responsive text-nowrap p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Paid Date</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={7} align="center">
                              <div className="spinner-border spinner-border-lg text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata[0]?.subscribe_history ? (
                          this.state.listdata[0]?.subscribe_history.length > 0 ? (
                            this.state.listdata[0].subscribe_history.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    <strong>{item.subscribe_history_date}</strong>
                                  </td>
                                  <td>{item.subscribe_history_status}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={8}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(View);
